import { TaskExperience } from '@dialogue/silkroad'
import Analytics from 'APP/Services/Analytics'
import type { MemberTask } from 'APP/Store/MemberTasks'

export type MemberTaskOutcome = 'tapped' | 'completed' | 'dismissed' | 'failed'

/**
 * The payload of the MemberTask analytic event, discriminated by the task experience type.
 */
type MemberTaskEvent<T extends TaskExperience = TaskExperience> = {
  outcome: MemberTaskOutcome
  task_experience: T
  episode_id: string
  parameters: MemberTask<T>['parameters']
}

/**
 * Tracks MemberTask analytic event in a generic way while preserving type safety.
 */
export const trackMemberTask = <T extends TaskExperience = TaskExperience>(
  outcome: MemberTaskOutcome,
  task: MemberTask<T>
) => {
  const eventPayload: MemberTaskEvent<T> = {
    outcome,
    task_experience: task.task_experience,
    episode_id: task.episode_id,
    parameters: task.parameters,
  }

  return Analytics.trackEvent('member_task', eventPayload)
}
